export default values => ({
  brand: values && (values.brand || ''),
  model: values && (values.model || ''),
  priceWithIva: values && (values.priceWithIva || ''),
  iva: values && (values.iva || ''),
  isMovable: values && (values.isMovable || false)
});
